import { useEffect, useRef } from "react";

const COLORS = ["#f97316", "#fbbf24", "#8b5cf6", "#a78bfa", "#34d399"];

export function Confetti() {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    for (let i = 0; i < 40; i++) {
      const piece = document.createElement("div");
      const left = Math.random() * 100;
      const delay = Math.random() * 0.8;
      const duration = 2 + Math.random() * 2;
      const size = 6 + Math.random() * 6;
      const rotation = Math.random() * 720;

      piece.style.position = "fixed";
      piece.style.width = `${size}px`;
      piece.style.height = `${size}px`;
      piece.style.background = COLORS[Math.floor(Math.random() * COLORS.length)];
      piece.style.borderRadius = Math.random() > 0.5 ? "50%" : "2px";
      piece.style.left = `${left}%`;
      piece.style.top = "-20px";
      piece.style.opacity = "1";
      piece.style.zIndex = "9999";
      piece.style.pointerEvents = "none";
      piece.style.setProperty("--rot", `${rotation}deg`);
      piece.style.animation = `confetti-drop ${duration}s ease-out ${delay}s forwards`;

      container.appendChild(piece);
    }

    return () => { container.innerHTML = ""; };
  }, []);

  return <div ref={containerRef} className="fixed inset-0 pointer-events-none z-50" />;
}
